<template>
    <div>
        <FadeInTransition>
            <PageModal v-if="showModal" :modal-content="modalContent" />
        </FadeInTransition>

        <SlideLeftTransition>
			<HistoryBack />
		</SlideLeftTransition>

		<SlideRightTransition>
			<BubbleMenu />
		</SlideRightTransition>

        <slot />
    </div>
</template>

<script setup lang="ts">
    import { CookieHandler } from "@/composables/Classes/CookieHandler"
    import { useRequestStore } from '@/stores/requests'

    const requestStore = useRequestStore()
    const { globals } = storeToRefs(requestStore)

    const showModal = ref<Boolean>(false)
    const modalContent = ref<string>('')

    const today = Date.now()

    // const localeHead = useLocaleHead()
    const route = useRoute()
    // useHead(localeHead)

    useListen('toggleModal', (e) => {
        showModal.value = e.open

        e.content ? modalContent.value = e.content : modalContent.value = ''
    })

    // Temporary delete DB "Walbert_Schmitz" until realtime snyc is established
    window.indexedDB.deleteDatabase("Walbert_Schmitz")

    function head() {
        throw new Error('Function not implemented.')
    }

    const cookie = new CookieHandler(null)

    let cookieTimeout: any
    let eventTimeout: any
    
    const iframeDataReceiver = (event: any) => {
        if (event.origin === 'https://services.w-s.app') {
            const { payload } = event.data

            switch (payload.topic) {
                case 'triggerModal':
                    showModal.value = true
                    modalContent.value = 'cookies'
                    break;
            }
        }
    }

    onMounted(() => {
        window.addEventListener('message', iframeDataReceiver)

        if (!cookie.getCookie('showCookieConsent')) {
            cookieTimeout = setTimeout(() => {
                modalContent.value = 'cookies'
                showModal.value = true
            }, 2000)
        } else if (!cookie.getCookie('showEventConsent') && today < (globals.value.pagecontent.end_of_event * 1000)) {
            eventTimeout = setTimeout(() => {
                modalContent.value = 'upcoming-events'
                showModal.value = true
            }, 3000)
        }

        const cardClone = document.querySelector('.teaser-clone') as HTMLElement
        cardClone?.classList.add('hide-clone')
        cardClone?.remove()
    })

    watch(modalContent, (newVal, oldVal) => {
        if (oldVal === 'cookies' && newVal === '') {
            if (
                !cookie.getCookie('showEventConsent') && 
                today < (globals.value.pagecontent.end_of_event * 1000)) 
            {
                eventTimeout = setTimeout(() => {
                    modalContent.value = 'upcoming-events'
                    showModal.value = true
                }, 2000)
            }
        }
    })

    onBeforeUnmount(() => {
        clearTimeout(cookieTimeout)
    })
</script>
